import clsx from 'clsx'
import icChevDown from '../../assets/images/ic-chev-down.svg'
import Popover from '../commons/Popover'

export const HeaderSidebar = ({ companies = [], activeCompany = null, onSwitchCompany }) => {
    if (!activeCompany) return null

    return (
        <div id='header-sidebar' className='relative'>
            <div className='relative group flex items-center px-2 py-4 mx-1 mt-2 gap-3'>
                {activeCompany?.logo && <img src={activeCompany?.logo} className='min-w-6 h-6' alt='logo' />}
                <h1 className='font-semibold text-primary-60 line-clamp-2'>{activeCompany?.name}</h1>
                <Popover
                    className={clsx('left-none right-0 w-[300px]')}
                    classNameContainer='mt-auto'
                    trigger={
                        <img
                            src={icChevDown}
                            className='min-w-6 h-6 p-1 border border-transparent rounded cursor-pointer group-hover:border-neutral-30 transition-all duration-300'
                            alt='chev'
                        />
                    }
                >
                    {companies?.map((company) => (
                        <div
                            key={company?.id}
                            onClick={() => onSwitchCompany(company)}
                            className={
                                'flex text-nowrap space-x-4 px-4 py-3 items-center hover:bg-neutral-10 hover:text-primary-50 hover:font-semibold cursor-pointer'
                            }
                        >
                            <img src={company?.logo} className={'w-6 h-6'} alt={'company-logo'} />
                            <p>{company?.name}</p>
                        </div>
                    ))}
                </Popover>
            </div>
        </div>
    )
}
